// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VbNZP","select":"styles_select__3rmCB"};